import A from './types';
import isEmpty from 'lodash/isEmpty';

const conversionInterfaceData = (data) => {
  if (isEmpty(data)) {
    return null;
  }
  let planArr = Object.values(data);
  let newArr = [];
  let newObj = {};
  planArr.forEach(item => {
    newArr.push(item.key)
    newObj[item.key] = item.list
  })

  return {
    planName: newArr,
    planInfo: newObj
  };
};

const initData = {
  seat_num: 3,
  origin_price: 19900,
  show_name: 'Monthly',
  discount_price: 4900,
  pay_option: {
    key: 'continuing_standard',
  },
  firstName: 'abc',
  lastName: 'abc',
};

const initPayOption = {
  Standard: [
    {
      discount_months: -1,
      discount_period: null,
      discount_price: 4900,
      grade_option: {
        description: null,
        key: 'standard',
        order: 1,
        price: 4900,
        show_name: 'Standard',
        show_price: 19900,
      },
      key: 'continuing_standard',
      order: 4,
      origin_price: 19900,
      pay_duration: '1 month',
      pay_duration_months: 1,
      show_name: 'Monthly',
      validity: true,
    },
    {
      discount_months: -1,
      discount_period: null,
      discount_price: 4900,
      grade_option: {
        description: null,
        key: 'standard',
        order: 1,
        price: 4900,
        show_name: 'Standard',
        show_price: 19900,
      },
      key: 'continuing_standard',
      order: 4,
      origin_price: 19900,
      pay_duration: '1 month',
      pay_duration_months: 1,
      show_name: 'QUETLY',
      validity: true,
    },
  ],
  Premium: [{
    discount_months: -1,
    discount_period: null,
    discount_price: 14900,
    grade_option: {
      description: null,
      key: 'standard',
      order: 1,
      price: 14900,
      show_name: 'Standard',
      show_price: 19900,
    },
    key: 'continuing_standard',
    order: 4,
    origin_price: 19900,
    pay_duration: '1 month',
    pay_duration_months: 1,
    show_name: 'Monthly',
    validity: true,
  },
  {
    discount_months: -1,
    discount_period: null,
    discount_price: 4900,
    grade_option: {
      description: null,
      key: 'standard',
      order: 1,
      price: 4900,
      show_name: 'Standard',
      show_price: 19900,
    },
    key: 'continuing_standard',
    order: 4,
    origin_price: 19900,
    pay_duration: '1 month',
    pay_duration_months: 1,
    show_name: 'QUETLY',
    validity: true,
  }],
};

const initialState = {
  paymentInfo: {
    loading: false,
    error: false,
    plan: [],
    data: {},
    planList: []
  },
  queryAccount: {
    loading: false,
    error: false,
    isPremium: false,
    isStandard: false,
    data: {},
  },
  saveDirectOrderInfo: {
    loading: false,
    error: false,
  },
};

const judgePremium = (param, type) => {
  if (param.member_plan.toLowerCase() === type) {
    return true;
  }
  return false;
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.GET_CREATE_ACCOUNT_PAYMENT_INFO: {
      if (action.pending) {
        return {
          ...state,
          paymentInfo: {
            loading: true,
            error: false,
            plan: [],
            data: {},
            planList: []
          },
        };
      }
      if (action.payload.state_message && action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          paymentInfo: {
            loading: false,
            error: false,
            // plan: conversionInterfaceData(initPayOption),
            // data: initPayOption,
            plan: conversionInterfaceData(action.payload.data).planName,
            data: conversionInterfaceData(action.payload.data).planInfo,
            planList: Object.values(action.payload.data)
          },
        };
      }
      return {
        ...state,
        paymentInfo: {
          loading: false,
          plan: [],
          error: action.payload.message ? action.payload.message : action.payload.state_message,
          data: {},
          planList: []
        },
      };
    }
    case A.QUERY_USER_ACCOUNT_OR_NOT: {
      if (action.pending) {
        return {
          ...state,
          queryAccount: {
            loading: true,
            error: false,
            isPremium: false,
            isStandard: false,
            data: {},
          },
        };
      }
      if (action.payload.message === 'success') {
        return {
          ...state,
          queryAccount: {
            loading: false,
            error: false,
            isPremium: judgePremium(action.payload.data, 'premium'),
            isStandard: judgePremium(action.payload.data, 'standard'),
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        queryAccount: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
          isPremium: false,
          isStandard: false,
          data: {},
        },
      };
    }

    case A.SAVE_DIRECT_ORDER_INFO: {
      if (action.pending) {
        return {
          ...state,
          saveDirectOrderInfo: {
            loading: true,
            error: false,
            orderUrl: '',
          },
        };
      }
      if (action.payload.message === 'success') {
        return {
          ...state,
          saveDirectOrderInfo: {
            loading: false,
            error: 'Success',
            orderUrl: `${window.location.origin}/create-payment/?ID=${action.payload.data['account_id']}&firstName=${action.meta.firstName}&lastName=${action.meta.lastName}`,
          },
        };
      }
      return {
        ...state,
        saveDirectOrderInfo: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
          orderUrl: '',
        },
      };
    }

    case A.CREATE_DIRECT_ORDER_PAGE_ASYNG_ERROR_HIDE: {
      return {
        ...state,
        [action.payload.type]: {
          ...[action.payload.type],
          error: false,
        },
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/createAccount/reducer.js